import { useAppSelector } from "../../hooks/StoreHooks";

export const useFeatureFlags = () =>
  useAppSelector((state) => state.loginMetadata.featureFlagsList);

export const useSupportedLanguages = () =>
  useAppSelector((state) => state.loginMetadata.supportedLanguages);